import { PermissionSet } from '../../../types';
import { Text } from '../../Atoms/Text';
import { PermissionSetAssignmentCell } from './PermissionSetAssignmentCell';
import { setName } from './userAssignmentHelpers';

export interface PermissionSetAssignmentRowProps {
  label: string;
  value: string;
  permissionSets: PermissionSet[];
  emptyLabel: string;
  ariaLabel: string;
  canEdit: boolean;
  submitting?: boolean;
  onChange?: (value: string) => void;
}

export const PermissionSetAssignmentRow = ({
  label,
  value,
  permissionSets,
  emptyLabel,
  ariaLabel,
  canEdit,
  submitting,
  onChange = () => undefined
}: PermissionSetAssignmentRowProps) => (
  <div className="flex mb-8 items-center">
    <Text
      className="w-3/5"
      color="grey4"
      size="sm14">
      {label}
    </Text>
    <div className="w-full">
      {canEdit ? (
        <PermissionSetAssignmentCell
          value={value}
          permissionSets={permissionSets}
          ariaLabel={ariaLabel}
          disabled={submitting}
          onChange={onChange}
        />
      ) : (
        <Text
          color="grey12"
          size="sm14">
          {value ? setName(permissionSets, value) : emptyLabel}
        </Text>
      )}
    </div>
  </div>
);
